export const inchesToMillimeters = (inches: number) => Math.round(inches * 25.4 * 100) / 100;

export const milimetersToInches = (milimeters: number) => milimeters / 25.4;

export const cmsToMillimeters = (cms: number) => cms * 10;
